import { FC } from "react";
import PaneArea from "../../Common/PillsTab/_pane_area";
import { LocationProps } from "../../../../interfaces/RegionalPage";


interface Props {
    locations: LocationProps[]
}

const CategoryItems: FC<Props> = ({ locations }) => {

    return (
        <>
            {
                locations.length > 0 && locations.map((location) => {
                    return (
                        <PaneArea key={location.id} location={location} />
                    )
                })
            }
        </>
    );
};
export default CategoryItems;
